<template lang='pug'>
  .reserve-dialog.component( v-if=' business.id && !step' )
    h5.heading {{ $t('Make a Reservation by') }}
    h6.heading {{ $t('selecting a date & time below') }}
    vue-cal.vuecal--blue-theme.calendar(
      default-view="week"
      small
      :time-step='30'
      :disable-views="['years', 'month', 'year', 'day']"
      :selected-date="new Date()"
      :minDate='new Date()'
      :time-from='opening'
      :time-to='closing'
      :twelveHour='true'
      :events='events'
      :hide-weekdays='hide'
      @cell-click='set'
    )

  .reserve-dialog.component(v-else)
    h5.heading {{ $t('Please Check and Confirm') }}
    h6.heading {{ $t('your reservation details below') }}
    bf-wrapper.smaller.confirmation.content
      .rsv-dtls
        table
          thead
            tr
              th {{ $t('Business Name') }}
              td {{ business.name }}
            tr( v-if='customer' )
              th {{ $t('Customer Email') }}
              td {{ customer.email }}
            tr
              th {{ $t('Service') }}
              td.emphasize {{ reservation.service.title }}
            tr
              th {{ $t('Price') }}
              td ${{ reservation.service.price }}
            tr
              th {{ $t('Date') }}
              td {{ reservation.datetime.start.toLocaleDateString() }}
            tr
              th {{ $t('Reserved Time') }}
              td.emphasize {{ reservation.datetime.start.toLocaleTimeString() }}
            tr
              th {{ $t('Duration') }}
              td {{ reservation.service.duration }} {{ $t('mins') }}
        
      bf-wrapper.smaller.confirmation.content.message(v-if="reservation.message")
        h5( v-if='reservation.service.instructions' ) {{ reservation.service.instructions }}
        h5( v-else) {{ $t("Message to merchant")}}:
        p {{ reservation.message }}

      bf-flex.space-between
        bf-button.back.basic.secondary( @click.native='step--' )
          template( v-slot:text ) {{ $t('Back') }}
        bf-button.confirm.basic( @click.native='confirm' )
          template( v-slot:text ) {{ $t('Confirm') }}
</template>

<script>
  import { db } from '@/main'
  import VueCal from 'vue-cal'
  import 'vue-cal/dist/vuecal.css'

  export default {
    name: 'reserve-dialog.component',

    props: [ 'user', 'account', 'biz', 'business', 'service_id', 'customer', 'settings', 'msg' ],

    components: {
      VueCal
    },

    data() {
      return {
        reservation: {},
        reservations: [],
        rsvs: [],
        ords: [],
        orders: [],
        step: 0,
        mapper: {
          mon: 1,
          tue: 2,
          wed: 3,
          thu: 4,
          fri: 5,
          sat: 6,
          sun: 7
        }
      }
    },

    firestore() {
      if ( this.biz.id ) return {
        ords: {
          ref: db.collection( 'reservations' ).where( 'business_id', '==', this.business.id ),
        },

        rsvs: {
          ref: db.collection( 'reservations' ).where( 'account_id', '==', this.business.user_id )
        },

        services: db.collection('services').where( 'business_id', '==', this.business.id ),
        products: db.collection('products').where( 'business_id', '==', this.business.id ),
        catalogs: db.collection('catalogs').where( 'business_id', '==', this.business.id ),

        reservations: db.collection( 'reservations' ).where( 'account_id', '==', this.user.uid ),

        orders: db.collection( 'reservations' ).where( 'business_id', '==', this.biz.id )
      }
      else return {
        ords: {
          ref: db.collection( 'reservations' ).where( 'business_id', '==', this.business.id ),
        },

        rsvs: { // the merchant's user's reservations
          ref: db.collection( 'reservations' ).where( 'account_id', '==', this.business.user_id )
        },

        services: db.collection('services').where( 'business_id', '==', this.business.id ),
        products: db.collection('products').where( 'business_id', '==', this.business.id ),
        catalogs: db.collection('catalogs').where( 'business_id', '==', this.business.id ),

        // the current user's reservations
        reservations: db.collection( 'reservations' ).where( 'account_id', '==', this.user.uid ),

      }
    },

    computed: {
      hide() {
        let days = []
        Object.keys( this.business.cfg.days ).forEach( key => {
          if ( !this.business.cfg.days[key] ) days.push( this.mapper[key] )
        })
        return days
      },

      events() { 
        if ( this.business.cfg.closures ) {
          let closures = this.business.cfg.closures.map( c => {
            let startDate = new Date( c.start )
            let endDate = new Date( c.end )
            let background = true
            return { startDate, endDate, background }
          })
          
          closures.forEach( c => {
            for ( let i = 1; i <= 53; i++ ) {
              closures.push({ startDate: c.startDate.addDays(7*i), endDate: c.endDate.addDays(7*i) })
            }
          })

          return closures.concat([
            ...this.orders.map( r => ({...r, ...{
              startDate: r.datetime.start.toDate(),
              endDate: r.datetime.end.toDate(),
              class: 'merchant'
            }})),
            ...this.reservations.map( r => ({...r, ...{
              startDate: r.datetime.start.toDate(),
              endDate: r.datetime.end.toDate(),
              class: 'customer'
            }})),
            ...this.rsvs.map( r => ({...r, ...{
              startDate: r.datetime.start.toDate(),
              endDate: r.datetime.end.toDate(),
            }})),
            ...this.ords.map( o => ({...o, ...{
              startDate: o.datetime.start.toDate(),
              endDate: o.datetime.end.toDate(),
            }})).filter( evt => evt.datetime.end.toDate() > new Date() ),
          ])
        }
        else return []
      },

      opening() {
        let dt = new Date( this.business.cfg.opening )
        return dt.getUTCHours() * 60 + dt.getUTCMinutes()
      },

      closing() {
        let dt = new Date( this.business.cfg.closing )
        return dt.getUTCHours() * 60 + dt.getUTCMinutes()
      },
    },

    methods: {
      overlap(event, e) {
        e.stopPropagation()
        
        let start = new Date( event.start )

        let mins = start.getMinutes()
          start.setMinutes(0)
          if ( mins > 30 ) start.setMinutes(30)

          let items = this.services.concat( this.products, this.catalogs )
          let service = items.find( s => s.id == this.service_id )
          let end = new Date(start)
          end.setMinutes(
            start.getMinutes() +
            parseInt(service.duration - 1)
          )

          this.reservation = {
            business_id: this.business.id,
            service_id: this.service_id,
            account_id: this.account.id,
            user_id: this.user.uid,
            service: service,
            datetime: { start: start, end: end }
          }
          this.step = 1
      },

      set( start ) {
        if ( start ) {
          let mins = start.getMinutes()
          start.setMinutes(0)
          if ( mins > 30 ) start.setMinutes( 30 )

          let items = this.services.concat( this.products, this.catalogs )
          let service = items.find( s => s.id == this.service_id )
          let end = new Date(start)
          end.setSeconds(
            start.getSeconds() +
            parseInt( service.duration * 60 - 1 )
          )

          this.reservation = {
            business_id: this.business.id,
            service_id: this.service_id,
            account_id: this.account.id,
            user_id: this.user.uid,
            service: service,
            datetime: { start: start, end: end },
            message: this.msg
          }
          
          let unstartables = this.events.filter( e =>
            start < e.endDate &&
            start >= e.startDate
          )
          let endable = !this.events.filter( e => 
            end <= e.endDate &&
            end > e.startDate
          ).length

          if ( this.settings.multiple ) {
            unstartables = unstartables.filter( e => !e.service )
            endable = !this.events.filter( e => 
              end <= e.endDate &&
              end > e.startDate && !e.service
            ).length
          }

          let startable = !unstartables.length && ( start - new Date() ) / 1000 / 60 >= this.settings.lead

          let available = startable && endable
          if ( available && start > new Date() ) this.step = 1
        }
      },

      confirm() {
        db.collection( 'reservations' ).add({ ...this.reservation, message: this.msg }).then( doc => {
          db.collection( 'customers' )
          .where( 'account_id', '==', this.account.id )
          .where( 'business_id', '==', this.business.id )
          .get().then( snap => {
            // Initial reservations?  Add as customer if not already exists
            if ( !snap.docs.length ) db.collection( 'customers' ).add({
              email: this.account.email,
              name: this.account.name || '',
              account_id: this.account.id,
              account: this.account,
              business_id: this.business.id,
              business: this.business,
              initial_reservation: doc,
              invitation: {invited: true, joined: true}
            })
            this.$emit('close')
            this.$emit(
              'notify',
              this.$t('You have made a reservation with') + `${this.business.name}`
            )
          })

          db.collection('favorites').doc( `${this.account.id}->${this.business.id}` ).set({
            account_id: this.account.id,
            business_id: this.business.id
          })
        })
      }
    }
  }
</script>
<style scoped lang='stylus'>
  .message
    padding 10px
    background rgb(240 240 240)
    border-radius 5px
    h5
      margin-bottom 10px

  .space-between
    margin-top 20px
  >>> .vuecal__flex.vuecal__menu
    display none

  >>> .vuecal__event
    background repeating-linear-gradient(45deg, transparent, transparent 10px, #dddddd 10px, #dddddd 20px)
    > *
      display none

  // >>> .vuecal__time-cell
  //   padding-right 4px

  // >>> .weekday-label
  //   font-weight bold
  // >>> .vuecal__heading.today
  //   font-weight bold
  //   background rgb(54 131 149)
  //   color white
  // >>> .vuecal__time-column
  //   font-weight bold
  //   background rgb(54 131 149)
  // >>> .vuecal__time-cell
  //   color white
  // >>> .vuecal__now-line
  //   color orange
  //   border-top: 3px solid

  .reserve-dialog.component
    margin-top 0px
    .heading
      color rgb( 255 75 25 )
      text-align center
    .calendar
      margin 8px
      margin-top 8px
      box-shadow var(--shadow-box-shallow)

    .confirmation
      .rsv-dtls
        margin 24px auto
        border 1px solid rgba( 0 0 0 .1 )
        border-radius 5px
        overflow hidden
        box-shadow var(--shadow-box-shallow)
      table
        width 100%
        text-align left
        font-size 1.02em
        th, td
          padding 12px 16px
        th
          background rgba( 0 75 150 .1 )
          text-align right
          width 108px
          font-weight bold
        tr:nth-child(odd)
          background rgba( 0 0 0 .02 )
        .emphasize
          font-weight bold

  // >>> .vuecal__event
  //   height 100%
  //   max-width 10%

  >>> .customer
    background orange
    color white

  >>> .merchant
    background green
    color white
    height 100%

  // >>> .cancellation
  //   border 2px solid red
  // >>> .vuecal__flex.vuecal__title, >>> .vuecal__flex.weekday-label
  //   font-weight bold

  >>> .vuecal--week-view, >>> .vuecal--month-view, >>> .vuecal--day-view 
    border 2px solid grey
    border-radius 5px
    background rgb(250 250 250)
    
  >>> .vuecal__cell.selected
    background rgb(120 120 244)

  >>> .weekday-label
    font-weight bold

  >>> .vuecal__heading.today
    font-weight bold
    background rgb(54 131 149)
    color white

  >>> .vuecal__cell.today
    background rgb(54 131 149)
    color orange

  >>> .vuecal__cells.month-view
    font-weight bold
    font-size 1.3em

  >>> .vuecal__time-column
    font-weight bold
    background rgb(54 131 149)

  >>> .vuecal__time-cell
    color white
    
  >>> .vuecal--month-view
    height 450px
  >>> .vuecal--month-view.today
    color orange
  >>>  .vuecal__cell-events-count
    background orange 

  // >>> .vuecal__cell-events
  //   background gray
  //   height 100%
  //   color blue

  >>> .vuecal__now-line
    color orange
    border-top: 3px solid
</style>
